define(['jquery', 'jquery.transit', 'modernizr', 'container', 'module-tv-layout-gallery', 'module-tv-layout-header',
        'module-tv-moley-tv-series-poster', 'module-tv-moley-tv-series-about', 'module-tv-layout-distribution', 'module-tv-layout-team', 'module-tv-layout-cast-characters'],
    function ($, transit, modernizr, container, moduleTvLayoutGallery, moduleTvLayoutHeader,
              modulePoster, moduleAbout,
              moduleTvLayoutDistribution, moduleTvLayoutTeamFactory, moduleTvLayoutCastCharacters) {

        return (function () {

            const name = 'tv-moley-tv-series';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);

            const moduleTvLayoutTeamCreativeTeam = moduleTvLayoutTeamFactory.create();
            const moduleTvLayoutTeamWriters = moduleTvLayoutTeamFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                itemsKeys: [],
                items: new Map(),
                canNavigateAction: 0
            };

            view.startup = function () {

                if(view.publicVars.moduleLayoutHeaderConfig) {
                    moduleTvLayoutHeader.init(view.publicVars.moduleLayoutHeaderConfig);
                }

                if(view.publicVars.modulePosterConfig) {
                    view.privateVars.itemsKeys.push('poster');

                    view.privateVars.items.set('poster', {
                        init: false,
                        module: modulePoster,
                        config: view.publicVars.modulePosterConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleAboutConfig) {
                    view.privateVars.itemsKeys.push('about');

                    view.privateVars.items.set('about', {
                        init: false,
                        module: moduleAbout,
                        config: view.publicVars.moduleAboutConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleLayoutCreativeTeamConfig) {
                    view.privateVars.itemsKeys.push('creative-team');

                    view.privateVars.items.set('creative-team', {
                        init: false,
                        module: moduleTvLayoutTeamCreativeTeam,
                        config: view.publicVars.moduleLayoutCreativeTeamConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleLayoutWritersConfig) {
                    view.privateVars.itemsKeys.push('writers');

                    view.privateVars.items.set('writers', {
                        init: false,
                        module: moduleTvLayoutTeamWriters,
                        config: view.publicVars.moduleLayoutWritersConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleLayoutCastCharactersConfig) {
                    view.privateVars.itemsKeys.push('cast-characters');

                    view.privateVars.items.set('cast-characters', {
                        init: false,
                        module: moduleTvLayoutCastCharacters,
                        config: view.publicVars.moduleLayoutCastCharactersConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleLayoutGalleryConfig) {
                    view.privateVars.itemsKeys.push('gallery');

                    view.privateVars.items.set('gallery', {
                        init: false,
                        module: moduleTvLayoutGallery,
                        config: view.publicVars.moduleLayoutGalleryConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleLayoutDistributionConfig) {
                    view.privateVars.itemsKeys.push('distribution');

                    view.privateVars.items.set('distribution', {
                        init: false,
                        module: moduleTvLayoutDistribution,
                        config: view.publicVars.moduleLayoutDistributionConfig,
                        callbacks: {}
                    });
                }

                view.methods.handleCurrentScrollPosition();

                // moduleMediaCarousel.init(view.publicVars.moduleMediaCarouselConfig);
                // moduleVideoCarousel.init(view.publicVars.moduleVideoCarouselConfig);

            };

            view.bind = function () {
                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                });
            };

            view.methods = {
                handleCurrentScrollPosition: () => {

                    const systemCurrentScroll = $(document).scrollTop();

                    for (let [key, value] of view.privateVars.items) {

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);
                    }
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        const specialModifier = $(view.publicVars.cssId.headerCls).outerHeight();

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height + specialModifier))) {

                            view.methods.fireModuleStart(key);

                        }
                    }

                },

                fireModuleStart: (key) => {
                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                },
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
